import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Observable, catchError, throwError, map, finalize } from 'rxjs';
import { NotificationService } from './notification.service';
import { AuthService } from './auth.service';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private notification: NotificationService,
    private authService: AuthService,
  ) { }

  get apiUrl(): string { return environment.apiBaseUrl; }

  get headers(): HttpHeaders {
    const headerConfing: {} = {
      'Accept': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }

    return new HttpHeaders(headerConfing);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${this.apiUrl}${path}`, { headers: this.headers, params: params }).pipe(
      catchError((errors: HttpErrorResponse) => {

        this.errorHandler(errors);
        return throwError(() => errors);
      }),
      map((res: any) => {
        return res;
      }),
      finalize(() => {

      })
    );
  }

  post(path: string, body: FormData | FormGroup | Object, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.post(`${this.apiUrl}${path}`, body, { headers: this.headers, params }).pipe(
      catchError((errors: HttpErrorResponse) => {

        this.errorHandler(errors);
        return throwError(() => errors);
      }),
      map((res: any) => {
        return res;
      })
    );
  }

  update(path: string, body: FormData | FormGroup | Object, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.put(`${this.apiUrl}${path}`, body, { headers: this.headers, params }).pipe(
      catchError((errors: HttpErrorResponse) => {

        this.errorHandler(errors);
        return throwError(() => errors);
      }),
      map((res: any) => {
        return res;
      })
    );
  }

  delete(path: string, body: Object = {}, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.delete(`${this.apiUrl}${path}`, { headers: this.headers, params }).pipe(
      catchError((errors: HttpErrorResponse) => {

        this.errorHandler(errors);
        return throwError(() => errors);
      }),
      map((res: any) => {
        return res;
      })
    );
  }

  private errorHandler(error: HttpErrorResponse) {

    if (error.status === 401) {
      this.notification.showError('Unauthorized', 'Please login to continue');
      this.authService.clearAuthSession();
      this.router.navigate(['/login'], { replaceUrl: true });
    } else if (error.status === 422) {

      this.formatError(error);

    } else {
      let message = 'Something went wrong';
      if (error.error && typeof error.error === 'object' && error.error.message) {
        message = error.error.message;
      } else if (typeof error.error === 'string') {
        try {
          const parsed = JSON.parse(error.error);
          message = parsed.message || message;
        } catch (e) {
          message = error.error || message;
        }
      } else {
        message = error.message || message;
      }
      this.notification.showError(this.toUserFriendlyError(message), 'Error');
    }

  }

  private toUserFriendlyError(message: string): string {
    const raw = (message || '').toLowerCase();
    if (
      raw.includes('sqlstate') ||
      raw.includes('integrity constraint') ||
      raw.includes('sql:') ||
      raw.includes("column '") ||
      raw.includes('cannot be null')
    ) {
      if (raw.includes('state_id')) {
        return 'Please select a State.';
      }
      if (raw.includes('city_id')) {
        return 'Please select a City.';
      }
      if (raw.includes('country_id')) {
        return 'Please select a Country.';
      }
      return 'Please fill all required fields and try again.';
    }
    return message || 'Something went wrong';
  }

  private formatError(errors: HttpErrorResponse) {
    const errorsData = errors.error?.errors;

    if (errorsData && typeof errorsData === 'object') {
      Object.entries(errorsData).forEach(([key, value]) => {
        let valMessage = Array.isArray(value) ? value[0] : value;
        if (valMessage) {
          valMessage = String(valMessage)
            .replace('std applied tag', 'Tag Type')
            .replace('std_applied_tag', 'Tag Type');
        } else {
          valMessage = 'Validation error occurred.';
        }

        const title = errors.statusText && errors.statusText !== 'OK' ? errors.statusText : 'Validation Error';
        this.notification.showError(valMessage, title);
      });
    } else if (errors.error?.message) {
      const msg = String(errors.error.message)
        .replace('std applied tag', 'Tag Type')
        .replace('std_applied_tag', 'Tag Type');
      this.notification.showError(msg, 'Validation Error');
    }
  }
}


